module.exports = __webpack_public_path__ + "static/media_markt-d2b448a5cb3687b70b68f45f8355fc9c.svg";